export const HOST = 'https://authentication.rconnect.net.br'



// WEBPACK FOOTER //
// ./src/config/index.js